import { CrmType, FNIType, TradeInType } from '@upstart/harmony/lib/constants';

export function getStep4UiSchema(toggleButton: JSX.Element) {
  return {
    'ui:order': [
      'crmType',
      'otherCrmName',
      'dealersocket',
      'vinsolutions',
      'reynolds',
      'elead',
      'highergear',
      'tekion',
      'drivecentricId',
      'crmEmail',
      'crmEmailNew',
      'crmEmailUsed',
      'crmDefaults',
      'crmConfig',
      'fniType',
      'routeone',
      'dealertrack',
      'cudl',
      'tradeInManagerType',
      'vauto',
      'firstlook',
      'featureConfig',
      'informativConfig',
    ],
    otherCrmName: {
      condition: `crmType=${CrmType.STANDALONE}`,
    },
    dealersocket: {
      condition: `crmType=${CrmType.DEALERSOCKET}`,
      classNames: 'col-md-12',
      dealersocketId: { classNames: 'col-md-4' },
      dealersocketSiteNumber: { classNames: 'col-md-4' },
    },
    reynolds: {
      condition: `crmType=${CrmType.REYNOLDS}`,
      demoCounterText: {
        'ui:help':
          'Name of the Counter designated in Prospects page for marking demos',
      },
    },
    vinsolutions: {
      condition: `crmType=${CrmType.VINSOLUTIONS}`,
    },
    elead: {
      condition: `crmType=${CrmType.ELEAD}`,
    },
    highergear: {
      condition: `crmType=${CrmType.HIGHERGEAR}`,
    },
    tekion: {
      condition: `crmType=${CrmType.TEKION}`,
    },
    drivecentricId: {
      condition: `crmType=${CrmType.DRIVECENTRIC}`,
    },
    routeone: {
      condition: `fniType=${FNIType.ROUTEONE}`,
    },
    dealertrack: {
      condition: `fniType=${FNIType.DEALERTRACK}`,
    },
    cudl: {
      condition: `fniType=${FNIType.CUDL}`,
    },
    crmConfig: {
      skateAlerts: {
        classNames: 'col-md-6',
        'ui:help': 'Dealersocket Only',
      },
      restrictedDealAccess: {
        classNames: 'col-md-6',
        'ui:help': 'VinSolutions, DealerSocket and HigherGear',
      },
      editSoldUndelivered: {
        classNames: 'col-md-6',
        'ui:help': 'VinSolutions Only',
      },
      useAppointmentsIntegration: {
        classNames: 'col-md-6',
        'ui:help': 'VinSolutions, Elead and DGDG Only',
      },
    },
    crmDefaults: {
      condition: `crmType!=${CrmType.STANDALONE}`,
      type: { classNames: 'col-md-6', 'ui:help': 'for wizard leads' },
      sourceId: { classNames: 'col-md-6', 'ui:help': 'for wizard leads' },
      crmUserId: {
        classNames: 'col-md-6',
        'ui:help': 'default salesperson for wizard leads',
      },
      adminUserId: {
        classNames: 'col-md-3',
        'ui:help': 'for full-access API integration',
      },
      automationUserId: {
        classNames: 'col-md-3',
        'ui:help': 'for automation tests',
      },
    },
    vauto: {
      condition: `tradeInManagerType=${TradeInType.VAUTO}`,
      entityId: {
        classNames: 'col-md-6',
      },
      username: {
        classNames: 'col-md-6',
      },
      login: {
        classNames: 'col-md-12',
        username: {
          classNames: 'col-md-6',
        },
        password: {
          classNames: 'col-md-6',
        },
      },
    },
    firstlook: {
      condition: `tradeInManagerType=${TradeInType.FIRSTLOOK}`,
      dealerId: {
        classNames: 'col-md-4',
      },
      partnerId: {
        classNames: 'col-md-4',
      },
      passcode: {
        classNames: 'col-md-4',
      },
    },
    featureConfig: {
      shiftDigital: {
        classNames: 'config-group',
        enabled: {
          classNames: 'col-md-4',
          'ui:widget': toggleButton,
        },
        taggingEnabled: {
          classNames: 'col-md-4',
          'ui:widget': toggleButton,
        },
        retailerID: {
          classNames: 'col-md-12',
        },
        dealerID: {
          classNames: 'col-md-12',
        },
        apiToken: {
          classNames: 'col-md-12',
        },
        useShiftOffers: {
          classNames: 'col-md-12',
        },
        importShiftAccessories: {
          classNames: 'col-md-12',
        },
        importShiftPricing: {
          classNames: 'col-md-12',
        },
      },
      unite: {
        classNames: 'config-group',
        enabled: {
          classNames: 'col-md-4',
          'ui:widget': toggleButton,
        },
        taggingEnabled: {
          classNames: 'col-md-4',
          'ui:widget': toggleButton,
        },
        dealerCode: {
          classNames: 'col-md-12',
        },
      },
      autodata: {
        classNames: 'config-group',
        enabled: {
          classNames: 'col-md-12',
          'ui:widget': toggleButton,
        },
        dealerId: {
          classNames: 'col-md-12',
        },
      },
      informativ: {
        classNames: 'config-group',
        enabled: {
          classNames: 'col-md-4',
          'ui:widget': toggleButton,
        },
        dealershipId: {
          classNames: 'col-md-12',
        },
      },
    },
  };
}
